import {webhookSvg as Icon__small__webhookSvg} from '../Icon__small/Icon__small--webhook.js'

export var webhook = {
  name: 'webhook',
  category: 'icon',
  colorable: true,
  svg: Icon__small__webhookSvg,
};
